/**
 * Video Background
 */
function setup_video(e){
    var config = [];
    if($('#bgvid').length) config.push({el:"#bgvid", srcs:"#bgvid-srcs"});
    var attr_key = e==="desktop" ? "desktop-poster" : "mobile-poster"


    for(var i=0; i<config.length; i++){
        var vid_id = config[i].el;
        var video = $(vid_id);
        if(video.length){  
            var poster = video.attr(attr_key);
            video.attr("poster",poster);
			
            if($(config[i].srcs).length>0) {
				
                for(var o=JSON.parse($(config[i].srcs).text())[e],d=0;d<o.length;d++){
                    video.append('<source content="default-src *; style-src \'self\' http://* \'unsafe-inline\'; script-src \'self\' http://* \'unsafe-inline\' \'unsafe-eval\'" src="'+o[d].src+'" type="'+o[d].type+'">');
                }
            }    
        }
    }    
}

$(window).on("load", function() {
	650 < $(window).width() ?
		setup_video("desktop") :
		setup_video("mobile");
});

$(document).ready( function() {

	console.log("document is ready!")

	// mobile menu nav handling
	$('.menu-toggle').on('click', function(){
		$(this).toggleClass('closer');
		$('body').toggleClass('menu-open');
		$('.nav-primary').toggleClass('active');
	});

	$('.caret').on('click', function(e) {
		var submenu = $(e.currentTarget).siblings('.sub-menu');

		if( submenu.hasClass('open') ) {
			submenu.removeClass('open');
			submenu.slideUp();
		} else {
			$('.sub-menu').slideUp();
			$('.sub-menu').removeClass('open');			
			submenu.slideDown();
			submenu.addClass('open');
		}
		
	});

	// sticky footer
	var minH = $(window).height() - ( $('header.banner').height() + $('footer').outerHeight());
	$('.wrap').css({minHeight:minH});

	// banner slider
	if( $('.banner-slider') ) {
		$('.banner-slider').slick({
			arrows: false,
			dots: false,
			autoplay: true,
			fade: true,
			autoplaySpeed: 3000
		});
	}
	
	//init Swipe
	// $( '.swipebox' ).swipebox({
	// 	hideBarsDelay:0,
	// });

	//expander handling
	$('.expander-title').on("click", function() {
		$(this).toggleClass('open');
		$(this).siblings('.expander-content').slideToggle();
	})
});
/*

GOOGLE MAPS
var apiKey = '';
var lat = 1;
var lng = 1; 
$(document).ready(function(){
	if ($('#map').length){
	 	// Asynchronously Load the map API 
    var script = document.createElement('script');
    script.src = "//maps.googleapis.com/maps/api/js?callback=initialize&key="+apiKey;
    document.body.appendChild(script);	
	}
});
		
function initialize() {
	var location = {lat: lat, lng:lng}
	var map;
	var mapOptions = {
		zoom:15,
		center: location,
		scrollwheel: false
	};
	
	map = new google.maps.Map(document.getElementById("map"), mapOptions);       
	var marker = new google.maps.Marker({
		position: location,
		map: map,
	});                

}

*/

